// Gallery thunbmails
const thumbnailSwiper = new Swiper(".gallery-thumbs", {
  slidesPerView: "auto",
  spaceBetween: 10,
  freeMode: true,
  watchSlidesProgress: true,
  direction: "vertical",
});

// Gallery main images
const swiper = new Swiper(".gallery-images", {
  slidesPerView: 1,
  spaceBetween: 10,
  centeredSlides: true,
  loop: true,
  thumbs: {
    swiper: thumbnailSwiper,
  },
  breakpoints: {
    768: {
      effect: "fade",
      centeredSlides: false,
    },
  },
  on: {
    beforeTransitionStart: function (swiper) {
      const activeSlide = swiper.slides[swiper.previousIndex];
      const activeVideo = activeSlide.querySelector("video");

      if (activeVideo) {
        activeVideo.pause();
      }
    },
    slideChangeTransitionEnd: function (swiper) {
      const activeSlide = swiper.slides[swiper.activeIndex];

      const activeVideo = activeSlide.querySelector("video");

      if (activeVideo) {
        activeVideo.play();
      }
    },
  },
});

// Complementary products swiper
const complementarySwiper = new Swiper(".complementary-swiper", {
  slidesPerView: 1.2,
  spaceBetween: 20,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    768: {
      slidesPerView: 1,
    },
  },
});

// Mute video
document.querySelectorAll(".btn-video-mute").forEach((button) => {
  button.addEventListener("click", (e) => {
    const slides = e.currentTarget
      .closest(".swiper-wrapper")
      .querySelectorAll(".swiper-slide");

    slides.forEach((slide) => {
      const video = slide.querySelector("video");

      if (video) {
        slide.classList.toggle("video-muted");

        if (video.muted) {
          video.muted = false;
        } else {
          video.muted = true;
        }
      }
    });
  });
});

// Play or pause video
document
  .querySelectorAll(".gallery-images .btn-video-pause")
  .forEach((button) => {
    button.addEventListener("click", (e) => {
      const slide = button.closest(".swiper-slide");
      const video = slide.querySelector("video");

      if (video.paused) {
        video.play();
        slide.classList.remove("video-paused");
      } else {
        video.pause();
        slide.classList.add("video-paused");
      }
    });
  });

// Play or pause video
document.querySelectorAll(".gallery-images video").forEach((video) => {
  video.addEventListener("click", (e) => {
    const slide = video.closest(".swiper-slide");

    if (video.paused) {
      video.play();
      slide.classList.remove("video-paused");
    } else {
      video.pause();
      slide.classList.add("video-paused");
    }
  });
});
